module.exports = __webpack_public_path__ + "static/media/circle icon-2_new.1ab659a7.png";